<template>
  <router-view/>
</template>

<script lang="ts">
import {defineComponent, nextTick, onMounted, reactive, toRefs, watch} from "vue";
// import {useStore} from "vuex";
// import {Mutations} from "@/core/store/enums/StoreEnums";
import {initializeComponents} from "@/core/plugins/arcui";
import eventBus from "@/core/services/eventBus";
import authenticationService from "@/core/services/AuthenticationService";
// import {useRoute, useRouter} from "vue-router";
import bookService from "@/app/services/bookService";
import arcidService from "@/app/services/arcidService";

// import persistentStorage from "@/core/store/PersistentStorage";
// import { useUnleashContext, useFlag } from '@unleash/proxy-client-vue'

// import unleashClient from "@/core/services/unleashClient"
// import persistentStorage from "@/core/store/PersistentStorage";

export default defineComponent({
  name: "app",
  mounted() {
    if (localStorage.Lang != null) this.$i18n.locale = localStorage.Lang;
    else localStorage.Lang = this.$i18n.locale = "en";
  },
  setup() {
    // const store = useStore();
    // const route = useRoute();
    // const router = useRouter();

    // const store = persistentStorage;
    // console.log(store.authentication?.user)
    // const user = reactive(store.authentication?.user)
    // const userRef = toRefs(user)
    // console.log('user:', user, userRef)
    // const updateContext = useUnleashContext()

    // if (user?.districtId) {
    //   console.log('user.districtId:', user.districtId)
    //   unleashClient.setContextField('districtId', user.districtId);
    // }
    // else {
    //   console.log('ELSE!')
    //   unleashClient.setContextField('districtId', '');
    // }
    // if (user?.currentInstance?.gradeId) {
    //   console.log('user?.currentInstance?.gradeId', user.currentInstance.gradeId)
    //   unleashClient.setContextField('gradeId', user.currentInstance.gradeId);
    // }
    // else {
    //   unleashClient.setContextField('gradeId', '');
    // }

    onMounted(() => {
      /**
       * this is to override the layout config using saved data from localStorage
       * remove this to use config only from static config (@/core/config/DefaultLayoutConfig.ts)
       */

      // store.commit(Mutations.OVERRIDE_LAYOUT_CONFIG);

      nextTick(() => {
        initializeComponents();
      });

      eventBus.$on('loggedIn', () => {
        bookService.loadGenres(authenticationService.currentUser().irla || null, null);
        bookService.loadRecommendations();
        bookService.loadBookshelfSubscriptions();

        
          // if (store.authentication.user?.districtId) {
          //   unleashClient.setContextField('districtId', store.authentication.user.districtId);
          // }
          // else {
          //   unleashClient.setContextField('districtId', '');
          // }

          // if (store.authentication.user?.currentInstance?.gradeId) {
          //   unleashClient.setContextField('gradeId', store.authentication.user.currentInstance.gradeId);
          // }
          // else {
          //   unleashClient.setContextField('gradeId', '');
          // }
        
      });

      // Periodically call ARC ID to ensure the user stays logged in.
      window.setInterval(() => {
        arcidService.extendSession();
      }, 5 * 60 * 1000);

    });

    // watch(
    //   () => userRef.value,
    //   (newValue, oldValue) => {
    //     // Note: `newValue` will be equal to `oldValue` here
    //     // *unless* state.someObject has been replaced
    //     console.log('newValue:', newValue, 'oldValue:', oldValue)
    //   },
    //   { deep: true }
    // )
  }
});
</script>

<style lang="scss">
@import "bootstrap-icons/font/bootstrap-icons.css";
@import "apexcharts/dist/apexcharts.css";
@import "quill/dist/quill.snow.css";
@import "animate.css";
@import "sweetalert2/dist/sweetalert2.css";
@import "nouislider/distribute/nouislider.css";
@import "@fortawesome/fontawesome-free/css/all.min.css";
@import "socicon/css/socicon.css";
@import "line-awesome/dist/line-awesome/css/line-awesome.css";
@import "dropzone/dist/dropzone.css";
@import "@vueform/multiselect/themes/default.css";
@import "prism-themes/themes/prism-shades-of-purple.css";
@import "element-plus/dist/index.css";

// Main demo style scss
@import "core/assets/sass/plugins";
@import "core/assets/sass/style";

// Dark mode demo style scss
//@import "core/assets/sass/plugins.dark";
//@import "core/assets/sass/style.dark";

//RTL version styles
//@import "core/assets/css/style.rtl.css";
</style>
